/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsConfigAwsAdvisorResource extends models.RecommendationBaseForFinopsResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsConfigAwsAdvisorResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsConfigAwsAdvisorResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsConfigAwsAdvisorResource>): RecommendationForFinopsConfigAwsAdvisorResource {
        let obj = Object.assign(new RecommendationForFinopsConfigAwsAdvisorResource(), model);
        RecommendationForFinopsConfigAwsAdvisorResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsConfigAwsAdvisorResource>): RecommendationForFinopsConfigAwsAdvisorResource {
        if (!model) return null;
        return RecommendationForFinopsConfigAwsAdvisorResource.newInstance(<RecommendationForFinopsConfigAwsAdvisorResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsConfigAwsAdvisorResource) {
        if (!obj) return;

        models.RecommendationForFinopsConfigAwsAdvisorResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsConfigAwsAdvisorResource): boolean {
        if (models.RecommendationBaseForFinopsResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsConfigAwsAdvisorResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
